import './index.scss';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeGymRoomItems from '../../pages/change-gym-room/ChangeGymRoomItems';
import { useFetchAllGymRooms } from '../../../store/gym-management/GymHooks';

const ChangeGymRoom = () => {
  const { t } = useTranslation();
  const fetchGymRooms = useFetchAllGymRooms();

  useEffect(() => {
    fetchGymRooms().finally();
  }, []);

  return (
    <div className="change-gym-room-modal">
      <div className="change-gym-room-modal-body">
        <div className="change-gym-room-title">
          {t('CHANGE_GYM_ROOM_MODAL_TITLE')}
        </div>
        <div className="change-gym-room-content">
          <ChangeGymRoomItems />
        </div>
      </div>
    </div>
  );
};

export default ChangeGymRoom;
